import { MutableRefObject, useEffect, useState } from "react";
import { getLandingContainer } from "../views/utils/getLandingContainer";

export function useElementScroll( ref: MutableRefObject<null> ): number {
    const [scroll, setScroll] = useState<number>( 0 )
    const [container, setContainer]     = useState<Element>( getLandingContainer() )
    const onscrollHandler = () =>
        {
            try 
            {
                const lScroll = container.scrollTop
                const element = ref.current
                if(!!element){
                    const iScroll = ( element as HTMLDivElement ).getBoundingClientRect().top
                    const defScroll = lScroll - iScroll            
                    setScroll( defScroll )
                } 
            } 
            catch (e) 
            {            
                console.log(e)            
            }
        }

    useEffect(() => { 
        container.addEventListener("scroll", onscrollHandler)        
        return () => { 
            container.removeEventListener("scroll", onscrollHandler)
        }
    }, [])
    return scroll
}